import React from "react";
import Footer from "../../components/layout/footer";
import Header from "../../components/layout/header";
import FlashSale from "../Flash Sale/FlashSale";

const FAQs = () => {
  return (
    <>
      <Header />
      <div className="privacy-policy">
        <h1>Frequently Asked Questions (FAQs)</h1>
        <div className="privacy-policy-content">
          <h2>1. What do we Offer?</h2>
          <p>
            Kharutaai ('Formerly known as Prathamesh Balache Kapade), renowned
            for serving wide varieties of Infant Clothing, Baby Accessories,
            Toys, Cradles & lots more! We have Our Own In-House Manufacturing
            Brand 'Kharutaai', wherein we cater to Baby's Comfort Clothing,
            Ethnic & Festive Occasions & much more! We also have Rental Schemes
            on Baby Cradles for Naming Ceremony & do explore our Website!
          </p>

          <h2>2. How can I place an Order?</h2>
          <p>
            To place an Order, simply browse our Website & select the Products
            you wish to Purchase. Add the Products to your Baby Shopping Cart &
            proceed to Checkout. You will be prompted to Login & enter your
            Shipping Information & Payment Details. Once your Order is Received,
            you will on Whatsapp Number with the Order Details.
          </p>

          <h2>3. What Payment Methods do you accept?</h2>
          <p>
            To Proceed Online Transaction, you will be shared a Payment QR,
            currently no other modes of payment except UPI /QR can be availed.
            <br />
            We accept various payment methods @our Offline Store, including
            Debit Cards & Credit Cards.
            <br />
            For more information about Payment Options, please visit our Payment
            Information Tab.
          </p>

          <h2>4. How can I track my order?</h2>
          <p>
            After your Order has been shipped, you will receive a Shipping
            Confirmation on Email/Whatsapp Number, with a Tracking Number. You
            can use this Tracking Number to track your Order by visiting the
            Courier’s Website.
          </p>

          <h2>5. Can I Return a Product?</h2>
          <p>
            Yes, you can return items within 10 Days from the Date of Delivery
            of Product, provided they are in their original condition with all
            the tags intact & original packaging. To initiate a Return Process,
            please contact our Customer Service Team. For more details on our
            Return Policy, please refer to our Return Policy Tab.
          </p>

          <h2>6. How do I contact Customer Support?</h2>
          <p>
            if you need any assistance or have queries, you can reach out to us
            via Email or Whatsapp Number :
            <br />
            Email : Connect@Kharutaai.com
            <br />
            Whatsapp : +919833368284
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default FAQs;
